import React, {useContext, useEffect, useState} from 'react';
import {OrdersSadanContext} from "../OrdersSadanContext";
import axios from "axios";
import {prefixUrl} from "../../../utils/utilsData";
import Select from "react-select";
import {
  changeNameHandler, changePackageTypeHandler
} from "../../SellFactorSdanaShop/FactorJOZ/AddProductSectionSadanFunctions";
import {toast} from "react-toastify";
import {addToTableData} from "./functions";
import "./addKalaStyle.scss"

function AddToTableSection(props) {
  const helper = useContext(OrdersSadanContext);
  const setData = helper.setData
  const data = helper.data


  const [productList, setProductList] = useState([{}])
  const [currentSelected, setCurrentSelected] = useState({})

  const getData = async () => {
    const res = await axios.get(prefixUrl() + `/cartTable/?request=productList`)
    if (res.data.status) {

      const array = res.data.data.map(ob => ({value: ob.productId, label: ob.productName}))
      setProductList(array)
    }
  }
  const changeNameHandler = async (object) => {
    setCurrentSelected(object)
  }
  const addToTableHandler = async () => {

    const value = currentSelected?.value;
    if (!value) {
      toast.info('لطفا یک  محصول انتخاب کنید.')
      return
    }
    const toastId = toast.loading('در حال دریافت اطلاعات...')
    const res = await axios.get(prefixUrl() + `/cartTable/?request=productDetail&productId=` + value)
    toast.dismiss(toastId)
    if (res.data.status) {
      console.log(res.data.data)
      const object = res.data.data
      addToTableData({object, setData, data})
    }
  }
  useEffect(() => {
    void getData()
  }, [])

  const customStyles = {

    control: (provided: Record<string, unknown>) => ({
      ...provided, height: 37, '&:hover': {
        border: '1px solid #B9B9B9', outline: '1px solid #B9B9B9'
      }, '&:focus': {
        border: '1px solid #B9B9B9', outline: '1px solid #B9B9B9'
      },
    }),

    option: (base, state) => ({
      ...base,
      color: state.isSelected ? "white" : "'#B9B9B9'",
      backgroundColor: state.isSelected ? "#B9B9B9" : "white",
      padding: ".3rem 2rem .3rem .3rem",
      cursor: "pointer",
      fontsize: '10'
    }),
  };

  return (<div
    className={"add__kala__section"}
  >
    <>
      <div className={'d-flex justify-content-center align-items-center'} style={{marginLeft: 10, width: 'max-content'}}>
        <div>جستجو:  &nbsp;</div>
        <div className={"react__select__parent"}>
          <Select
            options={productList}
            // onChange={(e) => console.log(e)}
            onChange={object => changeNameHandler(object)}
            // name='sample'
            placeholder='بر اساس نام'
            // defaultValue={2}
            // disabled={true}
            required={false}
            className='reactSelectStyleInAddProduct'
            // listStyle={{
            //   backgroundColor: '#fafafa', border: '1px solid #ccc',
            // }}
            styles={customStyles}
            // activeItemStyle={{ backgroundColor: '#e0e000' }}
            // iconWidth='50'
            // iconStyle={{
            //   fontSize: '26px',
            //   borderRadius: '0 5px 5px 0',
            // }}
            // purpose='search'
            // onSearch={(e) => console.log(e)}
            // onExactSearch={(e) => console.log(e)}
          />
        </div>

        <button
          className={"addKala__btn"}
          onClick={addToTableHandler}
        >
          <svg
            width={25}
            height={25}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="add-square 2" clipPath="url(#clip0_2834_147)">
              <path
                id="Vector"
                d="M10.6667 8.5H5.33333C5.06 8.5 4.83333 8.27333 4.83333 8C4.83333 7.72667 5.06 7.5 5.33333 7.5H10.6667C10.94 7.5 11.1667 7.72667 11.1667 8C11.1667 8.27333 10.94 8.5 10.6667 8.5Z"
                fill="#B9B9B9"
              />
              <path
                id="Vector_2"
                d="M8 11.1673C7.72667 11.1673 7.5 10.9407 7.5 10.6673V5.33398C7.5 5.06065 7.72667 4.83398 8 4.83398C8.27333 4.83398 8.5 5.06065 8.5 5.33398V10.6673C8.5 10.9407 8.27333 11.1673 8 11.1673Z"
                fill="#B9B9B9"
              />
              <path
                id="Vector_3"
                d="M10 15.1673H6C2.38 15.1673 0.833333 13.6207 0.833333 10.0007V6.00065C0.833333 2.38065 2.38 0.833984 6 0.833984H10C13.62 0.833984 15.1667 2.38065 15.1667 6.00065V10.0007C15.1667 13.6207 13.62 15.1673 10 15.1673ZM6 1.83398C2.92667 1.83398 1.83333 2.92732 1.83333 6.00065V10.0007C1.83333 13.074 2.92667 14.1673 6 14.1673H10C13.0733 14.1673 14.1667 13.074 14.1667 10.0007V6.00065C14.1667 2.92732 13.0733 1.83398 10 1.83398H6Z"
                fill="#B9B9B9"
              />
            </g>
            <defs>
              <clipPath id="clip0_2834_147">
                <rect width={16} height={16} fill="white"/>
              </clipPath>
            </defs>
          </svg>

        </button>
      </div>
    </>
  </div>);
}

export default AddToTableSection;